import { useEffect, useState } from 'react';
import { useMoralisQuery } from 'react-moralis';
import { useBoolean } from '@chakra-ui/react';
import { IUser } from '../User/useUser';
import useDidMountEffect from 'src/utils/hooks/effects/didMount';

export enum State {
	LOADING,
	FETCHED,
}

const useUsers = () => {
	const [isLoading, setIsLoading] = useBoolean(true);
	const [state, handleState] = useState(State.LOADING);
	const [users, setUsers] = useState<IUser[]>([]);

	const [fetchedAddresses, setFetchedAddresses] = useState<string[]>([]);

	const query = useMoralisQuery(
		'GamerProfile',
		query => query.containedIn('address', fetchedAddresses),
		[fetchedAddresses],
		{ autoFetch: false }
	);

	useDidMountEffect(() => {
		setIsLoading.on();

		void query.fetch();
	}, [fetchedAddresses]);

	useDidMountEffect(() => {
		if (query.isLoading || query.isFetching) {
			return;
		}

		setIsLoading.off();
	}, [query.isLoading, query.isFetching]);

	useEffect(() => {
		if (isLoading) {
			handleState(State.LOADING);
		} else {
			handleState(State.FETCHED);
		}
	}, [isLoading]);

	useEffect(() => {
		const users = query.data.map(user => user.attributes as IUser);

		setUsers(users);
	}, [query.data]);

	return { state, data: users, fetch: setFetchedAddresses };
};

export default useUsers;
